import { render, staticRenderFns } from "./alarmRule.vue?vue&type=template&id=54a80b5e&scoped=true&"
import script from "./alarmRule.vue?vue&type=script&lang=js&"
export * from "./alarmRule.vue?vue&type=script&lang=js&"
import style0 from "./alarmRule.vue?vue&type=style&index=0&id=54a80b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a80b5e",
  null
  
)

export default component.exports